namespace Matrix.Data {
    export class RelationshipTypeColumns {
        static columnsKey = 'Data.RelationshipType';
    }
}
